import React from "react";

const isPositive = (val) => {
    if (!val) return false;
    const str = String(val).trim().toUpperCase();
    return str === "SI" || str === "YES" || str === "1" || str === "ATTIVO" || str === "DISPONIBILE" || str.includes("OK");
};

const formatVal = (val, fallback = "N/D") => {
    if (val === null || val === undefined || String(val).trim() === "") return fallback;
    return String(val);
};

const getMapsUrl = (item) => {
    if (item && item.geo_lat && item.geo_lon) {
        return `https://www.google.com/maps/search/?api=1&query=${item.geo_lat},${item.geo_lon}`;
    }
    return null;
};

const UnidataResult = (props) => {
    const details = props.data?.Unidata?.details;
    const address = props.address || "";

    if (!details || details.length === 0) {
        return (
            <div style={{ padding: '16px', color: '#64748b', fontStyle: 'italic', textAlign: 'center' }}>
                Nessun dettaglio disponibile per Unidata.
            </div>
        );
    }

    if (details.length > 1) {
        return (
            <div className="civicListContainer">
                <h4 className="civicListHeader">Civici e Scale Trovate ({details.length})</h4>
                <ul className="civicList">
                    {details.map((item, index) => {
                        const cNum = item.civico || item.Civico || "";
                        const mapsUrl = getMapsUrl(item);
                        return (
                            <li key={index} className="civicListItem">
                                <span>{address} {cNum} {item.scala_palazzina ? `(Scala ${item.scala_palazzina})` : ""}</span>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    {mapsUrl && (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={mapsUrl}
                                            className="mapsLinkBtn"
                                        >
                                            Google Maps ↗
                                        </a>
                                    )}
                                    {props.onSelectCivic && cNum && (
                                        <button
                                            className="searchCivicBtn"
                                            onClick={() => props.onSelectCivic(cNum)}
                                        >
                                            Cerca Civico
                                        </button>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }

    const item = details[0];

    const hasFtth = isPositive(item.ftth);
    const hasGpon = isPositive(item.gpon);
    const hasPt1000 = isPositive(item.pt_1000);
    const hasPt2500 = isPositive(item.pt_2500);
    const hasPt10g = isPositive(item.pt_10g);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {/* Profili e Tecnologie UNIDATA */}
            <div>
                <span style={{ fontSize: '0.78rem', fontWeight: '800', color: '#ff0f64', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Profili e Tecnologie
                </span>
                <div className="speedHighlightGrid">
                    <div className={`speedHighlightCard ${hasFtth ? 'speedHighlightCardActive' : ''}`}>
                        <span className="speedHighlightTitle" style={{ color: hasFtth ? '#059669' : '#64748b' }}>
                            FTTH
                        </span>
                        <span className="speedHighlightSubtitle" style={{ color: hasFtth ? '#059669' : '#64748b', fontWeight: '700' }}>{hasFtth ? 'Disponibile' : 'Assente'}</span>
                    </div>

                    <div className={`speedHighlightCard ${hasGpon ? 'speedHighlightCardActive' : ''}`}>
                        <span className="speedHighlightTitle" style={{ color: hasGpon ? '#059669' : '#64748b' }}>
                            GPON
                        </span>
                        <span className="speedHighlightSubtitle" style={{ color: hasGpon ? '#059669' : '#64748b', fontWeight: '700' }}>{hasGpon ? 'Attivo' : 'Non attivo'}</span>
                    </div>

                    <div className={`speedHighlightCard ${hasPt1000 ? 'speedHighlightCardSpeed' : ''}`}>
                        <span className="speedHighlightTitle" style={{ color: hasPt1000 ? '#059669' : '#94a3b8' }}>
                            1 Gbps
                        </span>
                        <span className="speedHighlightSubtitle" style={{ color: hasPt1000 ? '#059669' : '#94a3b8', fontWeight: '700' }}>{hasPt1000 ? 'PT 1000' : 'N/D'}</span>
                    </div>

                    <div className={`speedHighlightCard ${hasPt2500 ? 'speedHighlightCardSpeed' : ''}`}>
                        <span className="speedHighlightTitle" style={{ color: hasPt2500 ? '#059669' : '#94a3b8' }}>
                            2.5 Gbps
                        </span>
                        <span className="speedHighlightSubtitle" style={{ color: hasPt2500 ? '#059669' : '#94a3b8', fontWeight: '700' }}>{hasPt2500 ? 'PT 2500' : 'N/D'}</span>
                    </div>

                    <div className={`speedHighlightCard ${hasPt10g ? 'speedHighlightCard10G' : ''}`}>
                        <span className="speedHighlightTitle" style={{ color: hasPt10g ? '#059669' : '#94a3b8' }}>
                            10 Gbps
                        </span>
                        <span className="speedHighlightSubtitle" style={{ color: hasPt10g ? '#059669' : '#94a3b8', fontWeight: '700' }}>{hasPt10g ? 'PT 10G (XGS-PON)' : 'N/D'}</span>
                    </div>
                </div>
            </div>

            {/* Grid Parametri Rete & Infrastruttura */}
            <div className="statGrid">
                <div className="statCard">
                    <span className="statLabel">POP</span>
                    <span className="statValue" style={{ color: '#0284c7' }}>{formatVal(item.pop)}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">Stato Building</span>
                    <span className="statValue" style={{ color: '#059669' }}>{formatVal(item.stato_building)}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">Totale UI</span>
                    <span className="statValue">{formatVal(item.totale_ui)}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">PFS</span>
                    <span className="statValue">{formatVal(item.pfs)}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">PTE</span>
                    <span className="statValue">{formatVal(item.pte)}</span>
                </div>
                {getMapsUrl(item) && (
                    <div className="statCard">
                        <span className="statLabel">Mappa Geografica</span>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={getMapsUrl(item)}
                            style={{
                                color: '#0284c7',
                                fontWeight: '700',
                                textDecoration: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                marginTop: '4px'
                            }}
                        >
                            Google Maps ↗
                        </a>
                    </div>
                )}
            </div>

            {/* Zona */}
            {item.denom_zona && (
                <div style={{ background: '#f8fafc', padding: '10px 14px', borderRadius: '10px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.85rem', fontWeight: '600', color: '#64748b' }}>Denominazione Zona:</span>
                    <span style={{ fontSize: '0.95rem', fontWeight: '700', color: '#0f172a' }}>{item.denom_zona}</span>
                </div>
            )}
        </div>
    );
};

export default UnidataResult;